// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-box_product_box_section__eLp7P {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    align-items: center;
    justify-content: center;
}

.product-box_product_box__T1Y0C {
    width: 100%;
    height: 230px;
    max-width: 170px;
    border-radius: 5px;
    transition: transform 0.3s;
    background: linear-gradient(to top, #24261F, #191A17);
}
.product-box_product_box__T1Y0C:hover {
    transform: translateY(-8px);
}
.product-box_product_box__T1Y0C img {
    width: 100%;
    height: 172px;
    max-width: 130px;
    border: 1px solid #63665C;
    border-top-left-radius: 200px;
    border-top-right-radius: 200px;
}

@media (min-width: 1200px) {
    .product-box_product_box_section__eLp7P {
        width: 33.33%;
        margin-top: 100px;
    }

    .product-box_product_box__T1Y0C {
        width: 100%;
        height: 451px;
        max-width: 350px;
        border-radius: 10px;
        margin-bottom: 50px;
        background: linear-gradient(to top, #24261F, #191A17);
    }
    .product-box_product_box__T1Y0C img {
        width: 100%;
        height: 330px;
        max-width: 250px;
    }
    .product-box_product_box__T1Y0C p {
        font-size: 20px;
        margin-top: 43px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/product-box/product-box.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,qDAAqD;AACzD;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;QACnB,qDAAqD;IACzD;IACA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".product_box_section {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-top: 20px;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.product_box {\r\n    width: 100%;\r\n    height: 230px;\r\n    max-width: 170px;\r\n    border-radius: 5px;\r\n    transition: transform 0.3s;\r\n    background: linear-gradient(to top, #24261F, #191A17);\r\n}\r\n.product_box:hover {\r\n    transform: translateY(-8px);\r\n}\r\n.product_box img {\r\n    width: 100%;\r\n    height: 172px;\r\n    max-width: 130px;\r\n    border: 1px solid #63665C;\r\n    border-top-left-radius: 200px;\r\n    border-top-right-radius: 200px;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .product_box_section {\r\n        width: 33.33%;\r\n        margin-top: 100px;\r\n    }\r\n\r\n    .product_box {\r\n        width: 100%;\r\n        height: 451px;\r\n        max-width: 350px;\r\n        border-radius: 10px;\r\n        margin-bottom: 50px;\r\n        background: linear-gradient(to top, #24261F, #191A17);\r\n    }\r\n    .product_box img {\r\n        width: 100%;\r\n        height: 330px;\r\n        max-width: 250px;\r\n    }\r\n    .product_box p {\r\n        font-size: 20px;\r\n        margin-top: 43px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product_box_section": `product-box_product_box_section__eLp7P`,
	"product_box": `product-box_product_box__T1Y0C`
};
export default ___CSS_LOADER_EXPORT___;
